/**
 * @module common/DualAxis/fields/AxisNameField
 * @description 受控 Y 轴名称输入（对齐 YAxisSetting/YAxisName 布局）
 */

import React from 'react';
import { useIntl } from 'umi';
import { Input } from 'tea-component';

interface IAxisNameFieldProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

const AxisNameField: React.FC<IAxisNameFieldProps> = ({
  value,
  onChange,
  className = '',
}) => {
  const { formatMessage } = useIntl();

  return (
    <div className={`dbl-chart-setting-row ${className}`}>
      <span className="dbl-lable-gray-font">
        {formatMessage({ id: 'dbl_chart_primary_name' })}
      </span>
      <Input
        className="dbl-dual-axis-field__name-input"
        value={value}
        onChange={onChange}
        placeholder={formatMessage({
          id: 'dbl_chart_primary_basic_info_optional',
        })}
      />
    </div>
  );
};

export default React.memo(AxisNameField);
